import { ISobAnalyticsReportJoined } from 'partner360/models/report/sobAnalyticsReports/ISobAnalyticsReportJoined'

import { AcknowledgedStatus } from '../../../models'

export const isShowObligatoryFillInAll = (
  acknowledgedStatus: AcknowledgedStatus = AcknowledgedStatus.All,
  el: ISobAnalyticsReportJoined
) => {
  if (acknowledgedStatus === AcknowledgedStatus.Acknowledged) {
    return el.IsAcknowledgedCY == 1
  }
  if (acknowledgedStatus === AcknowledgedStatus.Unacknowledged) {
    return el.IsAcknowledgedCY == 0
  }

  return true
}
